module.exports = __webpack_public_path__ + "img/wifi-2.eb69b708.png";